import { commonUtils } from '@/helpers/commonUtils'
import styles from './ResetPwdCardMobile.module.less'
import cls from 'classnames'
import { FormItem, FormRow } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import AButton from '@/components/A/AButton/AButton'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import APassword from '@/components/A/APassword/APassword'
import { useRequest } from 'alova/client'
import { api } from '@/api'
import { useNavigate } from 'react-router-dom'
import { PAGE_LINKS } from '@/router/pageConst'
import { message } from 'antd'
import { ErrorKey } from '@/pages/LoginPage/components/LoginPagePc/LoginPagePc'

type ValidateType = Omit<ErrorKey, 'email' | 'email_registered'>

interface ErrorMsgMap {
  password?: { key: ValidateType, msg: string }
  rPassword?: { key: ValidateType, msg: string }
}


function ResetPwdCardMobile(props: { code: string }) {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const [password, setPassword] = useState<string | null>(null)
  const [rPassword, setRPassword] = useState<string | null>(null)
  const [errorMsgsMap, setErrorMsgsMap] = useState<ErrorMsgMap>({})
  const { loading, send } = useRequest(api.auth.submitResetPassword, { immediate: false })

  const validator = (password: string | null, rPassword: string | null) => {
    const map: ErrorMsgMap = {}
    if (!password) {
      map.password = { key: 'password', msg: t('login.message.text1') }
    } else if (password.length < 12) {
      map.password = { key: 'password_less_12', msg: t('login.message.text6') }
    } else {
      const hasUpper = /[A-Z]/.test(password)
      const hasLower = /[a-z]/.test(password)
      const hasNumber = /[0-9]/.test(password)
      if (!hasUpper || !hasLower || !hasNumber) {
        map.password = { key: 'password_contain_L&U&N', msg: t('login.message.text7') }
      }
    }
    if (!rPassword) {
      map.rPassword = { key: 'r_password', msg: t('login.message.text1') }
    }

    if (password && rPassword && password !== rPassword) {
      map.rPassword = { key: 'r_password_not_same', msg: t('login.inconsistentPassword') }
    }
    return map
  }

  const handleResetPwd = async () => {
    const map = validator(password, rPassword)
    setErrorMsgsMap(map)
    if (Boolean(map.password) || Boolean(map.rPassword)) {
      return
    }
    try {
      await send({ c: props.code, password: password! })
      message.success(t('resetPwdPage.resetPwdSuccess'))
      setTimeout(() => {
        navigate(PAGE_LINKS.login)
      }, 500)
    } catch (error) {
      const e = error as ApiError
      console.error(e.statusMessage)
      if (e.statusCode === 40001) {
        message.error(t('resetPwdPage.message.resetLinkCodeError'))
        return
      }
      message.error(e.statusMessage)
    }
  }

  return (
    <div className={cls(styles.resetPwdCard, styles.card)}>
      <img
        className={styles.brand}
        src={commonUtils.getImagePath('loginPage/login-brand.png')}
        alt=''
      />
      <FormRow>
        <FormItem
          label={t('login.password')}
          labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
          error={Boolean(errorMsgsMap.password)}
          errorMsg={errorMsgsMap.password?.msg}
          errorMsgRender={(msg) => <span className={cls(styles.formItemErrorMsg, styles[i18n.language])}>{msg}</span>}
        >
          <APassword
            testId='reset-pwd-password-input'
            className={styles.inputWidth}
            placeholder={t('login.enterPassword')}
            onChange={(e) => {
              setPassword(e.target.value)
              const map = validator(e.target.value, rPassword)
              setErrorMsgsMap(map)
            }}
            onBlur={() => {
              window.scrollTo(0, 0)
            }}
          />
        </FormItem>
      </FormRow>
      <FormRow>
        <FormItem
          label={t('login.confirmPassword')}
          labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
          error={Boolean(errorMsgsMap.rPassword)}
          errorMsg={errorMsgsMap.rPassword?.msg}
          errorMsgRender={(msg) => <span className={cls(styles.formItemErrorMsg, styles[i18n.language])}>{msg}</span>}
        >
          <APassword
            testId='reset-pwd-confirm-password-input'
            className={styles.inputWidth}
            placeholder={t('login.confirmPassword')}
            onChange={(e) => {
              setRPassword(e.target.value)
              const map = validator(password, e.target.value)
              setErrorMsgsMap(map)
            }}
            onBlur={() => {
              window.scrollTo(0, 0)
            }}
          />
        </FormItem>
      </FormRow>
      <AButton
        testId='reset-pwd-submit-btn'
        type='primary'
        size='LG'
        className={styles.nextBtn}
        loading={loading}
        onClick={handleResetPwd}
      >
        {t('resetPwdPage.submit')}
      </AButton>
    </div>
  )
}

export default ResetPwdCardMobile
